import { Pipe, PipeTransform } from '@angular/core';
import { App } from '@df/core/app';
import { ProcessorService } from '@df/ng/processor.service';

@Pipe({
    name: 'optionColor',
    standalone: true
})
export class OptionColorPipe implements PipeTransform {
    transform = optionColorPipe;
}

export function optionColorPipe(optionValue: number, attributeCode: string): string | undefined {
    const app = ProcessorService.injector.get(App);
    const attributeModel = app.resources.attribute.getExisting(attributeCode);
    if (!attributeModel) {
        app.logger.error('Attribute does not exist: ', attributeCode);
        return undefined;
    }
    return attributeModel.getOptionColor(optionValue);
}
